module.exports = __webpack_public_path__ + "src/assets/img/photo-fruit-2.ee82cb3c.png";